import React, { useState } from 'react';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import { Button, Checkbox, Dialog, FormControlLabel, Stack, Typography } from '@material-ui/core';
const ResetBalanceDialog = ({ open, onClose, onSave }) => {
  const [confirmed, setConfirmed] = useState(false);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg">
      <Stack style={{ padding: '2rem' }} alignItems={'center'}>
        <WarningRoundedIcon
          color="warning"
          sx={{
            fontSize: '5rem'
          }}
        />
        <Typography variant="h5" align="center">
          Are you sure you want to reset all balances?
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={confirmed}
              onChange={(e) => setConfirmed(e.target.checked)}
              name="checked"
              color="incorta"
            />
          }
          label={<Typography fontWeight={'bold'}>Yes I am sure</Typography>}
        />
        <Stack direction={'row'} fullWidth alignItems={'center'} justifyContent={'center'} gap={2}>
          <Button color="error" variant="contained" onClick={onClose}>
            Cancel
          </Button>
          <Button
            color="incorta"
            variant="contained"
            onClick={() => {
              if (confirmed) {
                onSave();
                onClose();
              }
            }}
            disabled={!confirmed}
          >
            Reset Balances
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default ResetBalanceDialog;
